(() => {
  if (customElements.get('product-delivery-time')) return;
  class ProductDeliveryTime extends HTMLElement {
    connectedCallback() {
      this.ids = JSON.parse(this.dataset.extendedVariants || '[]').map(String);
      this.regular = this.querySelector('[data-delivery-regular]');
      this.extended = this.querySelector('[data-delivery-extended]');
      this.properties = this.querySelectorAll('[data-delivery-property]');
      this.onChange = (event) => {
        const input = event.target;
        if (input.matches?.('input[name="id"]') && input.form?.id === this.dataset.formId) {
          this.showVariant(input.value);
        }
      };
      document.addEventListener('change', this.onChange);
      this.showVariant(document.getElementById(this.dataset.formId)?.querySelector('[name="id"]')?.value || this.dataset.variantId);
    }
    disconnectedCallback() {
      document.removeEventListener('change', this.onChange);
    }
    showVariant(id) {
      const extended = this.ids.includes(String(id));
      if (this.regular) this.regular.hidden = extended;
      if (this.extended) this.extended.hidden = !extended;
      this.properties.forEach(input => { input.disabled = !extended; });
    }
  }
  customElements.define('product-delivery-time', ProductDeliveryTime);

  const ownerName = '_3drifter_delivery_policy';
  let cartSync = Promise.resolve();
  const inFlight = new Map();
  class CartDeliveryTime extends HTMLElement {
    connectedCallback() {
      const propertyName = this.dataset.propertyName || 'Processing time';
      const lines = JSON.parse(this.dataset.lines || '[]');
      this.jobs = lines.map(line => {
        const before = Array.isArray(line.properties) ? Object.fromEntries(line.properties) : (line.properties || {});
        const properties = {...before};
        if (properties[ownerName] === 'fdm_v1') {
          delete properties['Lieferzeit / Delivery'];
          if (properties._3drifter_processing_label) delete properties[properties._3drifter_processing_label];
          delete properties._3drifter_processing_label;
        }
        if (line.extended) {
          properties[propertyName] = this.dataset.propertyValue;
          properties[ownerName] = 'fdm_v1';
          properties._3drifter_processing_label = propertyName;
        } else if (properties[ownerName] === 'fdm_v1') {
          delete properties[propertyName];
          delete properties[ownerName];
        }
        if (Object.keys(properties).length === Object.keys(before).length &&
            Object.keys(properties).every(key => properties[key] === before[key])) return null;
        const signature = JSON.stringify([line.key, properties]);
        if (inFlight.has(signature)) return inFlight.get(signature);
        const job = cartSync.catch(() => {}).then(async () => {
          const response = await fetch(this.dataset.changeUrl, {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({id: line.key, properties})
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error('Delivery information could not be saved');
        });
        cartSync = job;
        inFlight.set(signature, job);
        job.finally(() => inFlight.delete(signature)).catch(() => {});
        return job;
      }).filter(Boolean);
      this.ready = Promise.all(this.jobs);
      this.ready.catch(() => {});
      this.onSubmit = async (event) => {
        if (event.defaultPrevented) return;
        if (!['cart', 'CartDrawer-Form', 'cart-notification-form'].includes(event.target.id) || this.jobs.length === 0) return;
        if (event.submitter && event.submitter.name !== 'checkout') return;
        event.preventDefault();
        try {
          await this.ready;
          this.jobs = [];
          event.target.requestSubmit(event.submitter || undefined);
        } catch (error) {
          window.location.assign(this.dataset.cartUrl);
        }
      };
      document.addEventListener('submit', this.onSubmit, true);
    }
    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
    }
  }
  customElements.define('cart-delivery-time', CartDeliveryTime);
})();
